<template>
  <v-tooltip
    openDelay="70"
    contentClass="bm-tooltip"
    :minWidth="width"
    :maxWidth="width"
    :location="location"
    :origin="origin"
  >
    <template #activator="{ props: activatorProps }">
      <slot v-if="$slots.icon" v-bind="activatorProps" name="icon" />

      <v-icon
        v-else
        v-bind="activatorProps"
        :color="iconColor"
        class="tooltip-icon"
        :class="extraSmallIcon ? 'ic-14' : 'ic-18'"
      >
        {{ icon }}
      </v-icon>
    </template>
    <slot />
  </v-tooltip>
</template>

<script setup lang="ts">
import type { Anchor } from 'vuetify';

interface Props {
  location?: Anchor;
  origin?: Anchor | 'auto' | 'overlap';
  icon?: string;
  iconColor?: string | undefined;
  extraSmallIcon?: boolean;
  width?: string;
}

withDefaults(defineProps<Props>(), {
  location: 'end',
  origin: 'auto',
  icon: '$info',
  iconColor: undefined,
  extraSmallIcon: false,
  width: '276px'
});
</script>
